import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Sends a channel-era URL to its spotlight equivalent.
 *
 * The four /my-channel, /personal-channel and /channel-share paths could not
 * simply be renamed. A share invitation sits in somebody's inbox for seven
 * days, and the accept and decline links in that email point at the old path,
 * so deleting it would break invitations that were already sent. Bookmarks to
 * a personal channel have no expiry at all.
 *
 * `Navigate` on its own cannot do this: it takes a literal path, so a target
 * like "/spotlight/:id" would send the viewer to a page about a channel
 * called ":id". The params have to be filled in from the matched route first,
 * which is what this does.
 *
 * The query string comes across too, because the header links to the create
 * step as `/personal-channel/0?tab_id=1` and dropping that would land people
 * on the wrong tab.
 */
export default function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const location = useLocation();

  const target = Object.entries(params).reduce(
    (path, [name, value]) => path.replace(`:${name}`, value ?? ""),
    to
  );

  return <Navigate to={`${target}${location.search}`} replace />;
}
